import { Component, OnInit, ViewChild } from '@angular/core';
import {
  NgxGalleryOptions,
  NgxGalleryImage,
  NgxGalleryComponent,
  INgxGalleryImage,
} from 'ngx-gallery-9';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css'],
})
export class EventsComponent implements OnInit {
  @ViewChild('gallery') gallery: NgxGalleryComponent;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  isMobileLayout = false;

  currentlyEvent = 'Moda´n´play';
  events = [
    {
      name: 'Moda´n´play',
      id: 'moda-n-play',
      photos: [
        '../../../../assets/events/moda-n-play/Modanaplay_outdoor2.jpeg',
        '../../../../assets/events/moda-n-play/Modanaplay_equipe.jpeg',
        '../../../../assets/events/moda-n-play/Modanaplay_pecas_ambiente_longe.jpeg',
        '../../../../assets/events/moda-n-play/Modanaplay_pecas.jpg',
      ],
    },
    {
      name: 'Palestra Requalificação',
      id: 'palestra-requalificacao',
      photos: [
        '../../../../assets/events/palestra-requalificacao/palestra_CARTAZ.jpg',
        '../../../../assets/events/palestra-requalificacao/palestra_CONVITE.jpg',
        '../../../../assets/events/palestra-requalificacao/palestra_FAVIP.JPG',
        '../../../../assets/events/palestra-requalificacao/palestra_SENAC.JPG',
        '../../../../assets/events/palestra-requalificacao/palestra_Senai.jpeg',
        '../../../../assets/events/palestra-requalificacao/palestra_UFPE.jpeg',
      ],
    },
    {
      name: 'Oficinas de Formação',
      id: 'oficinas-de-formacao',
      photos: [
        '../../../../assets/events/oficina-conjuncao-olhares/0_materiais.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/1_picagem1.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/1_picagem2.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/2_aglutinante.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/4_secagem.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/5_montagem.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/5_montagem2.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/5_montagem3.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/bolsa_oval.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/bolsa_quadrada.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/bolsa_redonda.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/bolsa_retangular.jpg',
        '../../../../assets/events/oficina-conjuncao-olhares/fruteira.jpg',
      ],
    },
    {
      name: 'Oficinas de Experimentação',
      id: 'oficina-experimentacao',
      photos: [
        '../../../../assets/events/oficina-experimentacao/oficina_arthur.jpeg',
        '../../../../assets/events/oficina-experimentacao/oficina_ceci.jpeg',
        '../../../../assets/events/oficina-experimentacao/oficina_ceci2.jpeg',
        '../../../../assets/events/oficina-experimentacao/oficina_lais2.jpeg',
      ],
    },
    {
      name: 'Cochichando Sério',
      id: 'cochichando-serio',
      photos: [
        '../../../../assets/events/cochichando-serio/cochicho-serio1.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio2.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio3.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio4.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio5.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio6.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio7.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio8.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio9.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio10.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio11.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio12.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio13.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio14.jpg',
        '../../../../assets/events/cochichando-serio/cochicho-serio15.jpg',
      ],
    },
  ];

  ngOnInit(): void {
    this.galleryOptions = [
      {
        image: false,
        thumbnails: false,

        previewCloseOnClick: true,
        previewCloseOnEsc: true,
        // previewDownload: true,
        previewFullscreen: true,
        previewKeyboardNavigation: true,
        previewSwipe: true,
        previewZoom: true,
        lazyLoading: true,
      },
      {
        breakpoint: 500,
        width: '300px',
        height: '300px',
        thumbnailsColumns: 3,
      },
      { breakpoint: 300, width: '100%', height: '200px', thumbnailsColumns: 2 },
    ];

    this.galleryImages = this.events[0].photos.map((url) => ({
      small: url,
      medium: url,
      big: url,
    }));

    this.isMobileLayout = this.getIsMobile();
    window.onresize = () => {
      this.isMobileLayout = this.getIsMobile();
    };
  }

  openPreview(currentlyEvent): void {
    console.log(currentlyEvent);
    this.galleryImages = this.events
      .find((event) => event.id === currentlyEvent)
      .photos.map((url) => ({
        small: url,
        medium: url,
        big: url,
      }));

    setTimeout(() => {
      this.gallery.openPreview(0);
    }, 0);
  }

  getIsMobile(): boolean {
    const w = document.documentElement.clientWidth;
    const breakpoint = 992;

    if (w < breakpoint) {
      return true;
    } else {
      return false;
    }
  }
}
